import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>How Businesses Are Using Technology To Evolve During Covid-19</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In Episode #02, Mr. Gene Deems, the eGov and services manager from the department of natural resources joined us who discusses the evolution of technology, how businesses are using tech to stay afloat during the pandemic, the necessity of going digital, and the mindset that will set entrepreneurs on the path to growth despite the current barriers. Gene brings to light his own experience in the world of tech the start of which dates back 27 years, and his perspective on what entrepreneurs can learn from the history.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;